import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';

import { ListStyled } from './TrlIconTextList.styles';

export const TrlIconTextList = ({ list }) => (
  <ListStyled dense disablePadding>
    {list.map((listItem) => (
      <ListItem key={listItem.primaryDescr}>
        <ListItemIcon>
          <FontAwesomeIcon icon={listItem.icon} />
        </ListItemIcon>
        <ListItemText
          primary={listItem.primaryDescr}
          secondary={
            Array.isArray(listItem.secondaryDescr)
              ? listItem.secondaryDescr.join('\n')
              : listItem.secondaryDescr
          }
        />
      </ListItem>
    ))}
  </ListStyled>
);

TrlIconTextList.propTypes = {
  list: PropTypes.array.isRequired,
};
